import type { TLabReportStatus } from '@team-milva/lab-models/resources'

/**
 * Whether a delivery's TAT cannot be changed because of where its report is. Mirrors the guard in
 * lab-cloud's `updateOrderTatGroupService` — keep the two in step.
 *
 * Only a report that is waiting for its send day (`scheduled`) or whose send failed holds its TAT:
 * the daily job works the send day out from the TAT, and a failed send has not reached the customer
 * yet. An approved, sent or manually-sent delivery can still be re-timed — the frozen PDFs carry no
 * TAT, and the TAT only feeds the invoice, so a lab may correct it (and with it the price of a delay)
 * until the invoice itself is sent. That lock is separate and applies to every delivery.
 */
export function isDeliveryTatChangeBlocked(labReportStatus: TLabReportStatus): boolean {
  return labReportStatus === 'scheduled' || labReportStatus === 'sent-failed'
}
